module.exports = __webpack_public_path__ + "static/media/dust_mite.48b78f95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/dust_mite.jpg
// module id = 133
// module chunks = 0